/** История на поръчките, детайли, разписки и фактури. */
export default {
  planLabel: "План {{plan}}",
  orderNumber: "Поръчка №{{id}}",
  creditsCount_one: "{{count}} точка",
  creditsCount_other: "{{count}} точки",
  status: {
    paid: "Платена",
    pending_payment: "Изчаква плащане",
    cancelled: "Отказана",
    refunded: "Възстановена",
  },
  history: {
    title: "История на поръчките",
    subtitle: "Вашите покупки на точки с разписки и фактури.",
    count_one: "{{count}} поръчка",
    count_other: "{{count}} поръчки",
    empty: "Все още нямате поръчки",
    emptyBody: "Точките, които купите, ще се появят тук.",
    loadMore: "Покажи още",
    loadFailed: "Поръчките не можаха да бъдат заредени.",
    viewDetails: "Детайли за поръчката",
  },
  documents: {
    title: "Разписка и фактура",
    subtitle: "Документ №{{number}}",
    subtitlePending: "Документите се създават, когато ги отворите.",
    receipt: "Разписка за плащане",
    invoice: "Фактура",
    view: "Преглед",
    download_receipt: "Изтегли разписката",
    download_invoice: "Изтегли фактурата",
    failed: "Документът не можа да бъде зареден. Моля, опитайте отново.",
  },
  detail: {
    promo: "Промо код {{code}}",
    backToProfile: "Към профила",
    notFound: "Не открихме тази поръчка във вашия профил.",
    total: "Общо",
    summary: "Обобщение на поръчката",
    benefitsLevel: "Предимства {{level}}",
    transaction: "Детайли за плащането",
    placed: "Създадена",
    paid: "Платена",
    method: "Начин на плащане",
    cardVia: "Карта чрез {{bank}}",
    notChosen: "Не е избран",
    reference: "Референция от банката",
    receiptNumber: "Разписка №",
    currency: "Валута",
    billedTo: "Фактурирано на",
    noBilling: "Не са въведени данни за фактуриране.",
    statusNote: {
      pending_payment:
        "Плащането все още не е потвърдено. Ако сте го завършили, статусът ще се обнови скоро; в противен случай не е изтеглена сума.",
      cancelled: "Плащането е отказано или прекратено. Не е изтеглена сума и не са добавени точки.",
      refunded: "Сумата е възстановена по вашата карта. Точките остават във вашия профил.",
    },
  },
};
